import { ReactNode, useMemo, useState } from 'react';
import { withErrorBoundary } from '../../error-handling/withErrorBoundary';
import { FootnoteContextType, FootnoteContext } from './FootnoteContext';


function BasicFootnoteProvider({children}: {children: ReactNode}) {
    const [footnotes, setFootnotes] = useState<any[]>([]);

    const contextValue = useMemo<Omit<FootnoteContextType, 'footnotes'>>(() => {
        return {
            add: (footnote) => {
                setFootnotes((currentFootnotes) => [...currentFootnotes, footnote]);

                return () => {
                    setFootnotes((currentFootnotes) => currentFootnotes.filter((currentFootnote) => currentFootnote !== footnote));
                };
            },
        };
    }, []);

    return <FootnoteContext.Provider value={{ footnotes, ...contextValue }}>
        {children}
    </FootnoteContext.Provider>;
}

export const FootnoteProvider = withErrorBoundary(BasicFootnoteProvider, 'FootnoteProvider');
